/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react'
import { connect } from 'react-redux'
import moment from 'moment'
import { Button, Form, Input } from 'semantic-ui-react'
import DashboardActions from '../../reducers/dashboardReducer'

class DashboardDateInput extends React.PureComponent {
  onDateChange = (field, value) => {
    const { setOrderStartEndAt, orderStartAt } = this.props
    let newValue

    if (field === 'orderStartAt') {
      newValue = Number(
        moment(value)
          .startOf('day')
          .format('x')
      )
    } else {
      newValue = Number(
        moment(value)
          .endOf('day')
          .format('x')
      )

      if (newValue < orderStartAt) {
        return
      }
    }

    setOrderStartEndAt(field, newValue)
  }

  onFormSubmit = () => {
    const { orderStartAt, orderEndAt, getOrderByDate, getCustomersByDate, getExpressOrder } = this.props

    if (orderEndAt < orderStartAt) {
      alert('Invalid date')
      return
    }

    getOrderByDate(orderStartAt, orderEndAt)
    getExpressOrder(orderStartAt, orderEndAt)
    getCustomersByDate(orderStartAt, orderEndAt)
  }

  render() {
    const { loading, orderStartAt, orderEndAt } = this.props

    const startAt = moment(orderStartAt).format('YYYY-MM-DD')
    const endAt = moment(orderEndAt).format('YYYY-MM-DD')

    return (
      <Form onSubmit={this.onFormSubmit}>
        <Form.Group inline style={{ marginBottom: 0 }}>
          <Form.Field>
            <label>Order from</label>
            <Input
              disabled={loading}
              type="date"
              name="startFrom"
              value={startAt}
              onChange={e => this.onDateChange('orderStartAt', e.target.value)}
            />
          </Form.Field>
          <Form.Field inline>
            <label>Order to</label>
            <Input
              disabled={loading}
              type="date"
              name="endAt"
              value={endAt}
              onChange={e => this.onDateChange('orderEndAt', e.target.value)}
            />
          </Form.Field>
          <Button type="submit" name="searchOrder" loading={loading} disabled={loading}>
            Search
          </Button>
        </Form.Group>
      </Form>
    )
  }
}

const mapState = ({ dashboard }) => ({
  loading: dashboard.loading || dashboard.customerLoading,
  orderStartAt: dashboard.orderStartAt,
  orderEndAt: dashboard.orderEndAt,
})

const mapDispatch = {
  getOrderByDate: DashboardActions.getOrderByDate,
  setOrderStartEndAt: DashboardActions.setOrderStartEndAt,
  getCustomersByDate: DashboardActions.getCustomersByDate,
  getExpressOrder: DashboardActions.getExpressOrders,
}

export default connect(
  mapState,
  mapDispatch
)(DashboardDateInput)



// WEBPACK FOOTER //
// ./src/components/Dashboard/DateInput.js